module.exports = __webpack_public_path__ + "components/country-flag/static/jm-10eca7e0e328ef9bec48b0d12a857fc8.svg";